const SESSION_STORAGE = {
  SHOWED_SHARE_CAMPAIGN_LOGIN_MODAL:
    'promobit.showed-share-campaign-login-modal',
  IS_SPONSOR_VISITED: 'promobit.is-sponsor-visited',
  INITIAL_SESSION_URL: 'promobit.initial-session-url',
  // Intent banner: marks that an intent overlay was already shown/dismissed in
  // the current session (1x/session cap). Prefix per intent type (first|exit).
  INTENT_BANNER_SHOWN: 'promobit.intent-banner-shown',
};

export default SESSION_STORAGE;
